export default __webpack_public_path__ + "static/2-f1042bb42b3af2e5bbccef58cc3b3d54.svg";